import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { defer, Observable, startWith } from 'rxjs';

export function fromControl<T>(control: FormControl<T> | FormGroup<{ [K in keyof T]: AbstractControl<any> }>): Observable<T> {
  // SAFETY(legacy): unreviewed, pre-dates this rule.
  if ((control as FormGroup)?.controls) {
    // SAFETY(legacy): unreviewed, pre-dates this rule.
    const formGroup = control as FormGroup;
    return defer(() => formGroup.valueChanges.pipe(startWith(formGroup.getRawValue())));
  } else {
    // SAFETY(legacy): unreviewed, pre-dates this rule.
    const formControl = control as FormControl<T>;
    return defer(() => formControl.valueChanges.pipe(startWith(formControl.getRawValue())));
  }
}
